import LikeHeartIcon from '../../src/legacy/LikeHeartIcon';
export default LikeHeartIcon;
